import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { InvoicesService } from '../_services/invoices.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { ParameterData } from '../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../_helpers/dataservice.service'
import { CustomerService } from '../_services/customer.service'
import { DebtorService } from '../_services/debtor.service'
import { Invoice, PaymentProcess, Debtor, InvoiceList, Account } from '../_models';
import { PaymentProcessService } from '../_services/paymentprocess.service';
import { AuthService } from '../_services/auth.service';
import { AppConfig } from '../_helpers/index';
import * as moment from 'moment';

@Component({
    selector: 'paymentedit',
    templateUrl: './paymentedit.component.html',
    styleUrls: ['../../assets/css/customer-list-table.css']
})



export class PaymentEditComponent implements OnInit {

    public customer_public_id: string;
    public customer_account_public_id: string;
    public user_id: string;
    public CreatedDate: string;
    myCheckbox: string;
    public saveisconfirmed: boolean;
    public paymentprocessForm: FormGroup;
    public cusPsp_accountsList: Account[] = [];
    public cusDebtor_accountsList: Account[] = [];
    public cusPsp_accountsListNew: Account[] = [];
    public cusDebtorList: Debtor[] = [];
    public invoicelist_temp: InvoiceList[] = [];
    public selectinvoicelist: Invoice[] = [];
    public allinvoicelist: Invoice[] = [];
    paymentPublic_key: string;
    PaymentTitle: string;
    invoiceTotalAmt: number = 0;
    created: any;
    currencysymbol: any;
    offsetTimeZone: any;
    offsetMinutes: any;
    offsetTimeVal: any;

    order: any = "name";
    ascending: any = true;
    public buttonValidate = false;

    public psp_accountName: string;
    public referenceValue: string;

    displayedColumns: string[] = ['select', 'created', 'name', 'total.value', 'status'];
    dataSourceInvoicesList = new MatTableDataSource();
    selection = new SelectionModel<Invoice>(true, []);
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    auth0Profile: any;

    constructor(
        private router: Router
        , private route: ActivatedRoute
        , private formBuilder: FormBuilder
        , private parameterData: ParameterData
        , private dataService: DataService
        , private invoicesService: InvoicesService
        , private readonly activatedRoute: ActivatedRoute
        , private paymentProcessService: PaymentProcessService
        , private _fbpayprocess: FormBuilder
        , private customerService: CustomerService
        , private debtorService: DebtorService
        , private auth: AuthService
    ) {


        this.InitialSetup();

    }//end cosnt

    InitialSetup() {
        var currentDate = new Date();
        this.created = currentDate;

        this.paymentprocessForm = this._fbpayprocess.group({
            is_confirmed: new FormControl(""),
            reference: new FormControl("", Validators.required),
            external_id: new FormControl(""),
            public_id: new FormControl(""),
            status: new FormControl(""),
            created: new FormControl(new Date()),
            description: new FormControl(""),
            debtor: this._fbpayprocess.group({
                public_id: new FormControl("Seleccione", Validators.required)
            }),

            user: this._fbpayprocess.group({
                public_id: this.user_id
            }),

            psp_operation: this._fbpayprocess.group({
                external_id: new FormControl(""),
                channel: new FormControl("WEB"),
                method: new FormControl("CASH"),
                processing_date: new FormControl(new Date(currentDate)),

                name: new FormControl("", Validators.required),
                public_id: new FormControl(""),
                customer_account: this._fbpayprocess.group({
                    public_id: new FormControl("Seleccione")
                }),
                psp_account: this._fbpayprocess.group({
                    public_id: new FormControl("", Validators.required)
                }),
                total: this._fbpayprocess.group({
                    currency: new FormControl(""),
                    value: new FormControl("")
                })
            }),
            invoice_list: this._fbpayprocess.array([
                ({
                    id: [""],
                    public_id: [""],
                    late_fee: this._fbpayprocess.group({
                        currency: [""],
                        symbol: [""],
                        value: (0)
                    }),
                    sub_total: this._fbpayprocess.group({
                        currency: [""],
                        symbol: [""],
                        value: (0)
                    }),
                    total: this._fbpayprocess.group({
                        currency: [""],
                        symbol: [""],
                        value: (0)
                    })
                })
            ])
        });
    }

    onCreatedChange(_event) {
        this.CreatedDate = _event;
    }

    ngOnInit() {
        var browserStorage;
        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
             browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            }
            else {
                this.customer_public_id = localStorage.getItem('companyId');
                this.user_id = localStorage.getItem('userId');

            }
        }
        else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
            this.user_id = localStorage.getItem('userId');
        }



         browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
        this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');

        if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

            this.offsetTimeZone = -5.00;
            this.offsetMinutes = 0;
            this.offsetTimeVal = (this.offsetTimeZone * 3600000) + 720000;
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
        }
        else {

            this.offsetTimeZone = browserStorage.getItem('timezone');
            this.offsetMinutes = 30;
            this.offsetTimeVal = (this.offsetTimeZone * 3600000) + 720000;
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;


        }

        this.getcustPsp_accountList();
        this.getcustDebtorList();

        let params: any = this.route.snapshot.params;
        this.paymentPublic_key = params.id;


        if (this.paymentPublic_key != null) {
            this.paymentProcessService.getPaymentProcess(this.paymentPublic_key).subscribe((paymentProcess: PaymentProcess) => {



                setTimeout(() => {
                    this.getchangecustAccountList(paymentProcess.psp_operation.psp_account.public_id);
                    this.paymentprocessForm = this._fbpayprocess.group({
                        is_confirmed: new FormControl(paymentProcess.is_confirmed),
                        reference: new FormControl(paymentProcess.reference),
                        external_id: new FormControl(paymentProcess.external_id),
                        public_id: new FormControl(paymentProcess.public_id),
                        status: new FormControl(paymentProcess.status),
                        description: new FormControl(paymentProcess.description),
                        created: new FormControl(new Date(paymentProcess.created.replace(/-/g, "/")).toISOString()),
                        debtor: this._fbpayprocess.group({
                            public_id: new FormControl(paymentProcess.debtor.public_id)
                        }),
                        psp_operation: this._fbpayprocess.group({

                            name: new FormControl(paymentProcess.psp_operation.name),
                            public_id: new FormControl(paymentProcess.psp_operation.public_id),
                            processing_date: new FormControl(new Date(paymentProcess.created.replace(/-/g, "/")).toISOString()),

                            psp_account: this._fbpayprocess.group({
                                public_id: new FormControl(paymentProcess.psp_operation.psp_account.public_id)
                            }),
                            total: this._fbpayprocess.group({
                                currency: new FormControl(paymentProcess.psp_operation.total.currency),
                                value: new FormControl(paymentProcess.psp_operation.total.value)
                            })
                        })
                    });

                    this.referenceValue = paymentProcess.reference;
                    this.psp_accountName = paymentProcess.psp_operation.psp_account.name;

                    this.selectinvoicelist = paymentProcess.invoice_list;
                    this.getcustDebtorInvoiceList(paymentProcess.debtor.public_id);
                }, 500);
                // 
            })
        }


    }


    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSourceInvoicesList.data.length;
        return numSelected === numRows;
    }


    masterToggle() {
        if (this.isAllSelected()) {
            this.selection.clear();
        }
        else {
            this.dataSourceInvoicesList.data.forEach(row => this.selection.select(row));
        }
    }

    selectRow(row) {

        if (this.selection.isSelected(row)) {
            this.selection.toggle(row);
            if (this.invoiceTotalAmt > 0) {
                this.invoiceTotalAmt = this.invoiceTotalAmt - Number(row.total.value);
            }
            else {
                this.invoiceTotalAmt = 0;
            }
        }
        else {
            this.selection.toggle(row);
            this.invoiceTotalAmt = this.invoiceTotalAmt + Number(row.total.value);
            this.selectinvoicelist.push(row);
        }
    }

    getcustPsp_accountList() {
        this.customerService.getCustomerAccountList(this.customer_public_id)
            .subscribe(data => {
                this.cusPsp_accountsList = data;
            });

    }//end

    getcustDebtorList() {
        this.customerService.getCustomerDebtorsList(this.customer_public_id)
            .subscribe(data => {
                let resources = data["data"];
                this.cusDebtorList = resources;
            });

    }//end

    getcustDebtorAccountList(public_id: string) {
        this.debtorService.getDebtorAccountList(public_id)
            .subscribe(data => {
                this.cusDebtor_accountsList = data;
            });

    }//end


    onChange(row) {
        row.checked = true;
        this.selection.toggle(row);
        this.selection.isSelected(row);
    }


    getchangecustAccountList(value) {


        this.cusPsp_accountsListNew = this.cusPsp_accountsList.filter(t => t.public_id == value);

        if (this.cusPsp_accountsListNew.length == 0) {

            this.currencysymbol = " ";

        }
        else {

            this.currencysymbol = this.cusPsp_accountsListNew[0].balance.symbol;

            let resources: any;
            this.dataSourceInvoicesList.data = resources;

        }
    }

    getcustDebtorInvoiceList(public_id: string) {
        this.invoiceTotalAmt = 0;
        if (public_id != 'Seleccione') {
            this.getcustDebtorAccountList(public_id);
            this.debtorService.getDebtorInvoiceList(public_id)
                .subscribe(data => {
                    let resources = data["data"];
                    this.allinvoicelist = resources.filter(item => item.status == 'PROCESSING' || item.status == 'NEW');
                    this.dataSourceInvoicesList.data = resources.filter(item => (item.status == 'PROCESSING' || item.status == 'NEW') && item.total.symbol == this.currencysymbol);


                    setTimeout(() => {
                        this.allinvoicelist.forEach(obj => {
                            this.selectinvoicelist.forEach(objs => {
                                if (obj.public_id == objs.public_id) {
                                    this.selectRow(obj);
                                }
                            });
                        })
                    }, 500);
                });
        }
        else {
            let resources: any;
            this.dataSourceInvoicesList.data = resources;
        }
    }//end

    onsubmit({ value }: { value: PaymentProcess }) {
        this.buttonValidate = true;
        value.invoice_list = this.selectinvoicelist;
        value.psp_operation.total.value = this.invoiceTotalAmt;




        var momentObj = moment(value.created);
        var createDate = momentObj.format("YYYY-MM-DD HH:mm:ss");

        let createDateGMT = this.convertGMTTime(createDate);

        var momentObjProc = moment(value.psp_operation.processing_date);
        var proceDate = momentObjProc.format("YYYY-MM-DD HH:mm:ss");

        let proceDateGMT = this.convertGMTTime(proceDate);

        value.created = createDateGMT;
        value.psp_operation.processing_date = proceDateGMT;

        if (value.is_confirmed == true) {
            value.is_confirmed = true;
        }
        else {
            value.is_confirmed = false;
        }
        this.paymentProcessService.confirmPaymentProcess(value.public_id, value)
            .subscribe((result) => {
                this.router.navigate(['/payments']);
            }, error => {
                console.log('Failed while trying to update the payments Details.' + error);
            });

    }

    /****GMT Converstion */
    convertGMTTime(startDate1) {
        var dateTimeZoneDiff = startDate1.split(/[- :]/),
            startDateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);

        var startDate2 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
        var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes));
        let startDate = moment(startDate3).format('YYYY-MM-DD HH:mm:ss');
        return startDate;
    }


}//end


